import { DisclaimerAccessValidator } from './disclaimerAccessValidator.js';
export class Cookies{
	init(){
        var self = this;
        let disclaimerAccessValidator = new DisclaimerAccessValidator();

		$(document).ready(function () {
			if (self.getCookie("cookie_agree") != 1 && self.getCookie("refuse_atonra") != 1){
				$('.cookies-tab').show();
            }

			if (self.getCookie("disclaimer_agree") != 1 && (document.body.classList.contains('theme') || document.body.classList.contains('themes-list-page'))){
				$('#disclaimerModal').modal('show');
			}

			$('#cookie_refuse').on('click', function() {
				document.cookie = 'refuse_atonra=1;path=/';
				$('.cookies-tab').fadeOut();
			});

			$('#cookie_agree').on('click', function() {
				self.cookieAgree('cookie_agree');
				$('.cookies-tab').fadeOut();
				return false;
            });

			$('#disclaimerModalDismiss').click(function () {
				if(document.getElementById('saveDisclaimerModal')
					&& document.getElementById('saveDisclaimerModal').checked
                    && disclaimerAccessValidator.hasAccess(document.getElementById('countrySelect').value)
                ) {
					self.cookieAgree('disclaimer_agree');
				}
			});
		});

	}
	cookieAgree(name){
		var self = this;
		self.setCookie(name, 1, 365);
	}
	getCookie(name) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	}
	setCookie(name, value, days) {
	    var d = new Date;
	    d.setTime(d.getTime() + 24*60*60*1000*days);
	    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}
}